import axios from "axios";
import queryString from "qs";
import { v4 as uuidv4 } from "uuid";

const endsWith = (subject, suffix) =>
  subject.indexOf(suffix, subject.length - suffix.length) !== -1;

export const post = (url, data, serverToServer = false) => {
  const uuid = uuidv4();
  url = `${url}${url.indexOf("?") !== -1 ? "&" : "?"}uuid=${uuid}`;
  return axios({
    method: "post",
    url: url,
    data: data,
    headers: {
      "Content-Type": "application/json"
    }
  }).then((response) => {
    if (
      !serverToServer &&
      endsWith(response.request.responseURL, "access-denied")
    )
      window.location.href = "/";

    return response;
  });
};

export const get = (url, data, serverToServer = false) => {
  const uuid = uuidv4();
  return axios({
    method: "get",
    url: `${url}?${queryString.stringify(data)}&uuid=${uuid}`,
    headers: {
      "Content-Type": "application/json"
    }
  }).then((response) => {
    if (!serverToServer) {
      if (endsWith(response.request.responseURL, "access-denied")) {
        window.location.href = "/";
      }
    }
    return response;
  });
};

// Background jobs
export const cacheJobClassSuggestions = (domain, data) =>
  post(`${domain}/api/suggestion/cache/job_classication`, data, true);
export const cacheJobExpertSuggestions = (domain, data) =>
  post(`${domain}/api/suggestion/cache/job_experts`, data, true);
export const cacheJobDisciplineSuggestions = (domain, data) =>
  post(`${domain}/api/suggestion/cache/job_disciplines`, data, true);
export const cacheJobTaskSuggestions = (domain, data) =>
  post(`${domain}/api/suggestion/cache/job_tasks`, data, true);
export const cacheRequirementSuggestions = (domain, data) =>
  post(`${domain}/api/suggestion/cache/job_tasks_requirements`, data, true);
export const cacheRequirementQuestionSuggestions = (domain, data) =>
  post(`${domain}/api/suggestion/cache/job_requirements_questions`, data, true);
export const cacheRequirementApply = (domain, data) =>
  post(`${domain}/api/suggestion/cache/job_requirements_apply`, data, true);
export const cacheRequirementsForKnockouts = (domain, data) =>
  post(`${domain}/api/suggestion/cache/job_requirements_knockouts`, data, true);

// HIRING
export const candidateSelfApply = (slug, jobId) => (data) =>
  post(`/${slug}/jobs/${jobId}/api/apply`, data);
export const candidateSelfBook = (slug) => (data) =>
  post(`/${slug}/booking/api`, data);

// ADMIN
export const login = (data) => post("/api/login", data);
export const register = (data) => post("/api/register", data);
export const passwordResetRequest = (data) =>
  post("/api/password_reset_request", data);
export const passwordReset = (data) => post("/api/password_reset", data);
export const switchOrganization = (data) =>
  post("/api/switch_organization", data);
export const find = (data) => get("/api/search", data);
export const getJobPermissions = (data) => post("/api/job_permissions", data);
export const upsertJobPermissions = (data) =>
  post("/api/upsert_job_permissions", data);
export const deleteJobPermissions = (data) =>
  post("/api/delete_job_permissions", data);

export const upsertProfile = (data) => post("/api/profile/upsert", data);
export const upsertMyAvailability = (data) =>
  post("/api/profile/availability/upsert", data);
export const deleteMyAvailability = (data) =>
  post("/api/profile/availability/delete", data);

// PRESENCE
export const setUserPresence = (data) => post("/api/presence/user", data);
export const setContentPresence = (data) => post("/api/presence/content", data);

// APPLICATION
export const getTailwindCss = (data) => post("/api/tailwind", data);

// connected apps
export const getZoomMeetingUrl = (data) =>
  get("/connected_apps/zoom_get_meeting", data);

// organization
export const upsertOrganization = (data) =>
  post("/api/application/organizations/upsert", data);
export const upsertOrganizationProfile = (data) =>
  post("/api/org/organizations/upsert", data);
export const deleteOrganization = (data) =>
  post("/api/application/organizations/delete", data);

// invitation
export const upsertInvitation = (data) =>
  post("/api/application/invitations/upsert", data);
export const deleteInvitation = (data) =>
  post("/api/application/invitations/delete", data);
export const insertInvitationUser = (data) =>
  post("/api/invitation/user", data);

// experts
export const upsertExpert = (data) =>
  post("/api/application/experts/upsert", data);
export const deleteExpert = (data) =>
  post("/api/application/experts/delete", data);

// occupations
export const upsertOccupation = (data) =>
  post("/api/application/occupations/upsert", data);

export const deleteOccupation = (data) =>
  post("/api/application/occupations/delete", data);

export const upsertSystemQuestionSet = (data) =>
  post("/api/application/questionsets/upsert", data);
export const deleteSystemQuestionSet = (data) =>
  post("/api/application/questionsets/delete", data);
export const upsertSystemQuestion = (data) =>
  post("/api/application/questionsets/questions/upsert", data);
export const deleteSystemQuestion = (data) =>
  post("/api/application/questionsets/questions/delete", data);
export const sortSystemQuestion = (data) =>
  post("/api/application/questionsets/questions/sort", data);
export const upsertSystemQuestionFromRubric = (data) =>
  post("/api/opportunities/questionsets/questions/upsert", data);

export const getQuestionSets = (data) => post("/api/questionsets", data);
export const getQuestionSetDetailJob = (data) =>
  post("/api/questionsets/detail/job", data);
export const getQuestionSetDetailSystem = (data) =>
  post("/api/questionsets/detail/system", data);
export const cloneQuestionSetJob = (data) =>
  post("/api/questionsets/clone/job", data);
export const cloneQuestionSetSystem = (data) =>
  post("/api/questionsets/clone/system", data);

export const getJobPosts = (data) => post("/api/job_posts", data);
export const getJobDescriptionBlocks = (data) => post("/api/job/blocks", data);
export const cloneJobDescriptionBlocks = (data) =>
  post("/api/job/description/clone", data);

// ORG

// users
export const upsertOrgUser = (data) => post("/api/org/users/upsert", data);
export const deleteOrgUser = (data) => post("/api/org/users/delete", data);
export const deactivateUser = (data) => post("/api/org/users/deactivate", data);
export const reactivateUser = (data) => post("/api/org/users/reactivate", data);

// invitations
export const upsertOrgInvitation = (data) =>
  post("/api/org/invitations/upsert", data);
export const deleteOrgInvitation = (data) =>
  post("/api/org/invitations/delete", data);
export const resendInvitationUser = (data) =>
  post("/api/org/invitations/resend", data);

// locations
export const upsertLocation = (data) => post("/api/org/locations/upsert", data);
export const deleteLocation = (data) => post("/api/org/locations/delete", data);

// engagement event types
export const upsertEngagementEventType = (data) =>
  post("/api/org/engagementeventtypes/upsert", data);
export const deleteEngagementEventType = (data) =>
  post("/api/org/engagementeventtypes/delete", data);

// follow up types
export const upsertFollowUpType = (data) =>
  post("/api/org/followuptypes/upsert", data);
export const deleteFollowUpType = (data) =>
  post("/api/org/followuptypes/delete", data);

// dispositions
export const upsertFollowUpDisposition = (data) =>
  post("/api/org/followuptypes/dispositions/upsert", data);
export const deleteFollowUpDisposition = (data) =>
  post("/api/org/followuptypes/dispositions/delete", data);
export const sortFollowUpDisposition = (data) =>
  post("/api/org/followuptypes/dispositions/sort", data);

// demographic survey questions and options
export const upsertSurveyQuestion = (data) =>
  post("/api/org/survey/upsert", data);
export const deleteSurveyQuestion = (data) =>
  post("/api/org/survey/delete", data);
export const sortSurveyQuestion = (data) => post("/api/org/survey/sort", data);
export const upsertSurveyOption = (data) =>
  post("/api/org/survey/options/upsert", data);
export const deleteSurveyOption = (data) =>
  post("/api/org/survey/options/delete", data);
export const sortSurveyOption = (data) =>
  post("/api/org/survey/options/sort", data);
export const upsertSurveyResponse = (data) =>
  post("/api/people/survey/response/upsert", data);

// job close reasons
export const upsertJobCloseReason = (data) =>
  post("/api/org/jobclose/upsert", data);
export const deleteJobCloseReason = (data) =>
  post("/api/org/jobclose/delete", data);
export const sortJobCloseReason = (data) =>
  post("/api/org/jobclose/sort", data);

// external sources
export const upsertExternalSource = (data) =>
  post("/api/org/sources/upsert", data);
export const deleteExternalSource = (data) =>
  post("/api/org/sources/delete", data);
export const sortExternalSources = (data) =>
  post("/api/org/sources/sort", data);

// disqualification reasons
export const upsertDisqualificationReason = (data) =>
  post("/api/org/disqualification/upsert", data);
export const deleteDisqualificationReason = (data) =>
  post("/api/org/disqualification/delete", data);
export const sortDisqualificationReason = (data) =>
  post("/api/org/disqualification/sort", data);

// categories
export const upsertCategory = (data) =>
  post("/api/org/categories/upsert", data);
export const deleteCategory = (data) =>
  post("/api/org/categories/delete", data);

// subcategories
export const upsertSubcategory = (data) =>
  post("/api/org/categories/subcategories/upsert", data);
export const deleteSubcategory = (data) =>
  post("/api/org/categories/subcategories/delete", data);

// OPPORTUNITIES

// workflow question reviews
export const upsertRoleWorkflowQuestionComment = (data) =>
  post("/api/opportunities/roles/workflowquestionreview/add", data);
export const fetchQuestionReviews = (data) =>
  post("/api/opportunities/roles/workflowquestionreview/fetch", data);

// jobs
export const upsertJob = (data) => post("/api/opportunities/jobs/upsert", data);
export const deleteJob = (data) => post("/api/opportunities/jobs/delete", data);
export const getJobFieldOptions = (data) =>
  get("/api/opportunities/jobs/field_options", data);

// job owners
export const updateJobOwner = (data) =>
  post("/api/opportunities/jobs/owners/update", data);
export const getAvailableOwners = (data) =>
  post("/api/opportunities/jobs/owners", data);

// workflow steps
export const upsertRoleWorkflowStep = (data) =>
  post("/api/opportunities/jobs/workflowsteps/upsert", data);
export const deleteRoleWorkflowStep = (data) =>
  post("/api/opportunities/jobs/workflowsteps/delete", data);
export const sortRoleWorkflowStep = (data) =>
  post("/api/opportunities/jobs/workflowsteps/sort", data);
export const getRoleWorkflowStepsByJobId = (data) =>
  post("/api/opportunities/jobs/workflowsteps/get_by_job_id", data);
export const getWorkflowStepFieldOptions = (data) =>
  post("/api/opportunities/jobs/workflowsteps/field_options", data);
export const updateWorkflowRoundName = (data) =>
  post("/api/opportunities/jobs/workflowsteps/round_name", data);

// levels
export const upsertRoleLevel = (data) =>
  post("/api/opportunities/jobs/levels/upsert", data);
export const sortRoleLevel = (data) =>
  post("/api/opportunities/jobs/levels/sort", data);
export const deleteRoleLevel = (data) =>
  post("/api/opportunities/jobs/levels/delete", data);

// workflow questions
export const upsertRoleWorkflowQuestion = (data) =>
  post("/api/opportunities/jobs/workflowquestions/upsert", data);
export const deleteRoleWorkflowQuestion = (data) =>
  post("/api/opportunities/jobs/workflowquestions/delete", data);
export const sortRoleWorkflowQuestion = (data) =>
  post("/api/opportunities/jobs/workflowquestions/sort", data);

// job interviewer
export const upsertJobInterviewer = (data) =>
  post("/api/opportunities/jobs/interviewer/upsert", data);
export const deleteJobInterviewer = (data) =>
  post("/api/opportunities/jobs/interviewer/delete", data);

// job team member
export const upsertJobTeamMember = (data) =>
  post("/api/opportunities/jobs/member/upsert", data);
export const deleteJobTeamMember = (data) =>
  post("/api/opportunities/jobs/member/delete", data);
export const sortJobTeamMember = (data) =>
  post("/api/opportunities/jobs/member/sort", data);

// job description section
export const deleteAllJobSectionFromJob = (data) =>
  post("/api/opportunities/jobs/sections/delete/all", data);
export const uploadJobDescriptionFromGoogleDrive = (data) =>
  post("/api/opportunities/jobs/upload_from_google_drive", data);
export const fetchJobs = (data) => post("/api/opportunities/jobs/fetch", data);

// job tasks
export const upsertJobTask = (data) =>
  post("/api/opportunities/jobs/tasks/upsert", data);
export const deleteJobTask = (data) =>
  post("/api/opportunities/jobs/tasks/delete", data);
export const sortJobTasks = (data) =>
  post("/api/opportunities/jobs/tasks/sort", data);
export const getJobTaskSuggestions = (data) =>
  post("/api/opportunities/jobs/tasks/suggestions", data);

// (job) campaign plays
export const upsertCampaignPlay = (data) =>
  post("/api/opportunities/jobs/plays/upsert", data);
export const deleteCampaignPlay = (data) =>
  post("/api/opportunities/jobs/plays/delete", data);
export const sortCampaignPlays = (data) =>
  post("/api/opportunities/jobs/plays/sort", data);

// job requirements
export const upsertJobRequirement = (data) =>
  post(`/api/opportunities/jobs/jobrequirement/upsert`, data);
export const toggleJobRequirementTask = (data) =>
  post(`/api/opportunities/jobs/jobrequirement/upsert_tasks`, data);
export const deleteJobRequirement = (data) =>
  post(`/api/opportunities/jobs/jobrequirement/delete`, data);
export const sortJobRequirement = (data) =>
  post(`/api/opportunities/jobs/jobrequirement/sort`, data);
export const generateJobRequirementSuggestions = (data) =>
  post(`/api/job/competencies/generate`, data);
export const generateJobRequirementFromTask = (data) =>
  post(`/api/job/competency/from_task`, data);
export const generateJobRequirementFromDescription = (data) =>
  post(`/api/job/competency/from_description`, data);
export const refineJobRequirementWording = (data) =>
  post(`/api/job/competency/refine_wording`, data);
export const generateJobRequirementDefinitionSuggestion = (data) =>
  post(`/api/job/competencies/define`, data);
export const generateJobEvaluation = (data) =>
  post(`/api/job/evaluation/generate`, data);
export const refineJobEvaluationQuestion = (data) =>
  post(`/api/job/evaluation/refine_question`, data);
export const getJobEvaluationIndicators = (data) =>
  post(`/api/job/evaluation/get_indicators`, data);
export const invertJobEvaluationQuestion = (data) =>
  post(`/api/job/evaluation/invert_question`, data);
export const generateJobCreativeQuestion = (data) =>
  post(`/api/job/evaluation/creative`, data);
export const saveGeneratedJobRequirementSuggestions = (data) =>
  post(`/api/job/competencies/save_generated`, data);

// job candidates
export const upsertJobCandidate = (data) =>
  post("/api/opportunities/jobs/candidate/upsert", data);
export const upsertJobCandidateOffer = (data) =>
  post("/api/opportunities/jobs/candidate/offer", data);
export const upsertJobCandidateArchive = (data) =>
  post("/api/opportunities/jobs/candidate/archive", data);
//export const deleteJobCandidate = (data) => post("/api/opportunities/jobs/candidate/delete", data);
export const restoreJobCandidate = (data) =>
  post("/api/opportunities/jobs/candidate/restore", data);
export const getCandidateRejectionMessage = (data) =>
  post(`/api/opportunities/jobs/candidate/get_rejection_message`, data);
export const processResumeFile = (data) =>
  post("/api/people/resumeparser", data);

// job candidate answers
export const fetchJobCandidateAnswers = (data) =>
  post("/api/opportunities/jobs/candidate/answers/fetch", data);

// job appointments
export const getAppointmentOptions = (data) =>
  post("/api/opportunities/jobs/appointment/options", data);
export const upsertAppointment = (data) =>
  post("/api/opportunities/jobs/appointment/upsert", data);
export const upsertAppointments = (data) =>
  post("/api/opportunities/jobs/appointment/upsert_multiple", data);
export const deleteAppointment = (data) =>
  post("/api/opportunities/jobs/appointment/delete", data);
export const upsertAppointmentQuestionAssessment = (data) =>
  post("/api/appointment/assessment/question/upsert", data);
export const getAppointmentQuestionsByUserAppointmentId = (data) =>
  post("/api/appointment/question/get_by_user_appointment_id", data);
export const upsertRecommendation = (data) =>
  post("/api/appointment/recommendation/upsert", data);
export const upsertRecommendationOnly = (data) =>
  post("/api/recommendation/upsert", data);
export const cleanUpInterviewNotes = (data) =>
  post("/api/appointment/notes/cleanup", data);
export const checkRecommendation = (data) =>
  post("/api/recommendation/check", data);
export const checkAppointmentAudioUploadLock = (data) =>
  post("/api/check_appointment_audio_lock", data);

// skills
export const upsertSkill = (data) =>
  post("/api/opportunities/skills/upsert", data);
export const deleteSkill = (data) =>
  post("/api/opportunities/skills/delete", data);
export const getSkillWithQuestions = (data) =>
  post("/api/opportunities/skill_with_questions", data);

// question bank
export const upsertQuestionBank = (data) =>
  post("/api/opportunities/questions/upsert", data);
export const deleteQuestionBank = (data) =>
  post("/api/opportunities/questions/delete", data);
export const cloneQuestionBank = (data) =>
  post("/api/opportunities/questions/clone", data);
export const cloneQuestionBankMultiple = (data) =>
  post("/api/opportunities/questions/clone_multiple", data);

// job messages
export const upsertJobMessage = (data) =>
  post("/api/opportunities/pipeline/messages/upsert", data);
export const deleteJobMessage = (data) =>
  post("/api/opportunities/pipeline/messages/delete", data);

// self book invite
export const selfScheduleInvite = (data) =>
  post("/api/opportunities/pipeline/booking/invite", data);

// job posting sections
export const upsertJobSection = (data) =>
  post("/api/opportunities/jobdescriptions/sections/upsert", data);
export const deleteJobSection = (data) =>
  post("/api/opportunities/jobdescriptions/sections/delete", data);
export const sortJobSections = (data) =>
  post("/api/opportunities/jobdescriptions/sections/sort", data);
export const processJobDescriptionUpload = (data) =>
  post("/api/opportunities/jobdescriptions/upload", data);

// PEOPLE

// candidates
const peopleApiPrefix = "/api/people";
export const upsertCandidate = (data) =>
  post(`${peopleApiPrefix}/candidates/upsert`, data);
export const deleteCandidate = (data) =>
  post(`${peopleApiPrefix}/candidates/delete`, data);
export const fetchCandidate = (data) =>
  post(`${peopleApiPrefix}/candidates/fetch`, data);
export const searchCandidates = (data) =>
  post(`${peopleApiPrefix}/candidates/search`, data);
export const upsertCandidateUrl = (data) =>
  post(`${peopleApiPrefix}/candidates/url/upsert`, data);
export const deleteCandidateUrl = (data) =>
  post(`${peopleApiPrefix}/candidates/url/delete`, data);
export const upsertCandidateNote = (data) =>
  post(`${peopleApiPrefix}/candidates/note/upsert`, data);
export const fetchCandidateNoteEmail = (data) =>
  post(`${peopleApiPrefix}/candidates/note/email`, data);
export const deleteCandidateNote = (data) =>
  post(`${peopleApiPrefix}/candidates/note/delete`, data);
export const upsertCandidateResume = (data) =>
  post(`${peopleApiPrefix}/candidates/resume/upsert`, data);
export const advanceCandidateJobRound = (data) =>
  post(`${peopleApiPrefix}/candidates/advance`, data);
export const candidateFieldOptions = (data) =>
  post(`${peopleApiPrefix}/candidates/field_options`, data);
export const candidateTags = (data) =>
  post(`${peopleApiPrefix}/candidates/tags`, data);
export const jobsAvailableForCandidate = (data) =>
  post(`${peopleApiPrefix}/candidates/jobs/available`, data);

// staff
export const upsertStaff = (data) => post(`/api/org/staff/upsert`, data);
export const deleteStaff = (data) => post(`/api/org/staff/delete`, data);

// gallery image
export const upsertGalleryImage = (data) =>
  post("/api/org/images/upsert", data);
export const deleteGalleryImage = (data) =>
  post("/api/org/images/delete", data);
export const sortGalleryImage = (data) => post("/api/org/images/sort", data);

// core values
export const upsertCoreValue = (data) =>
  post("/api/org/corevalues/upsert", data);
export const deleteCoreValue = (data) =>
  post("/api/org/corevalues/delete", data);
export const sortCoreValue = (data) => post("/api/org/corevalues/sort", data);

// core values
export const upsertMessageTemplate = (data) =>
  post(`/api/people/messagetemplate/upsert`, data);
export const deleteMessageTemplate = (data) =>
  post(`/api/people/messagetemplate/delete`, data);
export const getMessageTemplate = (data) =>
  post(`/api/people/messagetemplate/fetch`, data);

// default job sections
export const upsertDefaultJobSection = (data) =>
  post("/api/org/jobsections/upsert", data);
export const deleteDefaultJobSection = (data) =>
  post("/api/org/jobsections/delete", data);
export const sortDefaultJobSections = (data) =>
  post("/api/org/jobsections/sort", data);

// content review
export const upsertContentReview = (data) =>
  post("/api/jobdesc_review/upsert", data);
export const upsertContentReviewReaction = (data) =>
  post("/api/content_review/reaction", data);
export const reviewerRemind = (data) => post("/api/reviewer/remind", data);

// marketing authors
export const upsertMarketingAuthor = (data) =>
  post("/api/marketing/authors/upsert", data);
export const deleteMarketingAuthor = (data) =>
  post("/api/marketing/authors/delete", data);

// marketing testimonials
export const upsertMarketingTestimonial = (data) =>
  post("/api/marketing/testimonials/upsert", data);
export const deleteMarketingTestimonial = (data) =>
  post("/api/marketing/testimonials/delete", data);

// marketing pages
export const upsertMarketingPage = (data) =>
  post("/api/marketing/pages/upsert", data);
export const deleteMarketingPage = (data) =>
  post("/api/marketing/pages/delete", data);
export const getPages = (data) => post("/api/marketing/pages/get", data);
export const uploadPageFromFile = (data) =>
  post("/api/marketing/page_upload_api", data);
export const uploadPageFromGoogleDrive = (data) =>
  post("/api/marketing/page_upload_google_api", data);

// marketing page sections
export const upsertMarketingPageSection = (data) =>
  post("/api/marketing/pages/sections/upsert", data);
export const deleteMarketingPageSection = (data) =>
  post("/api/marketing/pages/sections/delete", data);
export const sortMarketingPageSections = (data) =>
  post("/api/marketing/pages/sections/sort", data);

// marketing page extras
export const upsertMarketingPageExtra = (data) =>
  post("/api/marketing/pages/fields/upsert", data);
export const deleteMarketingPageExtra = (data) =>
  post("/api/marketing/pages/fields/delete", data);

// marketing categories
export const upsertMarketingCategory = (data) =>
  post("/api/marketing/categories/upsert", data);
export const deleteMarketingCategory = (data) =>
  post("/api/marketing/categories/delete", data);
export const sortMarketingCategories = (data) =>
  post("/api/marketing/categories/sort", data);

// marketing subcategories
export const upsertMarketingSubcategory = (data) =>
  post("/api/marketing/subcategories/upsert", data);
export const deleteMarketingSubcategory = (data) =>
  post("/api/marketing/subcategories/delete", data);
export const sortMarketingSubcategories = (data) =>
  post("/api/marketing/subcategories/sort", data);

// marketing categorized pages
export const upsertMarketingCategorizedPage = (data) =>
  post("/api/marketing/categorized_pages/upsert", data);
export const deleteMarketingCategorizedPage = (data) =>
  post("/api/marketing/categorized_pages/delete", data);
export const sortMarketingCategorizedPages = (data) =>
  post("/api/marketing/categorized_pages/sort", data);
export const sortMarketingSubCategorizedPages = (data) =>
  post("/api/marketing/subcategorized_pages/sort", data);
export const deleteMarketingSubCategorizedPage = (data) =>
  post("/api/marketing/subcategorized_pages/delete", data);

// marketing events
export const upsertMarketingEvent = (data) =>
  post("/api/marketing/events/upsert", data);
export const deleteMarketingEvent = (data) =>
  post("/api/marketing/events/delete", data);
export const upsertMarketingEventInstance = (data) =>
  post("/api/marketing/events/instances/upsert", data);
export const deleteMarketingEventInstance = (data) =>
  post("/api/marketing/events/instances/delete", data);
export const fetchMarketingEventInstanceRegistrations = (data) =>
  post("/api/marketing/events/instances/registrations", data);

// marketing plays
export const upsertMarketingPlay = (data) =>
  post("/api/marketing/plays/upsert", data);
export const deleteMarketingPlay = (data) =>
  post("/api/marketing/plays/delete", data);
export const sortMarketingPlays = (data) =>
  post("/api/marketing/plays/sort", data);

// companies
export const searchCompanies = (data) => post("/engagement/company/find", data);
